/** @format */
import { client } from '@toucan/client/global/axios';
import { Market, OperationFixture } from '@toucan/client/global/market';

export async function getOperations() {
    const { data } = await client.get<{ operations: OperationFixture[] }>(
        '/fixtures/operations'
    );

    return data;
}

export async function getMarkets() {
    const { data } = await client.get<{ markets: Market[] }>(
        '/fixtures/markets'
    );

    return data;
}
